globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.ConversionsController = (function(superClass) {

    utils.extend(ConversionsController, superClass);

    function ConversionsController() {
        return ConversionsController.__super__.constructor.apply(this, arguments);
    }

    $.extend(ConversionsController.prototype, {
        init: function(){
            if($('.btn-export-excel').length){
                var $btn = $('.btn-export-excel');

                globalThis.App.cable.subscriptions.create({
                    channel: 'CustomerSpace::InteractionsExcelExportChannel',
                    current_connected_key: $btn.data("current-connected-key")
                   }, {
                    received: function(data) {
                     if(data.export_finished) {
                       globalThis.App.cable.disconnect();
                       appCustomerSpace.Loader().stop();
                     }
                    }
                });
            }

            return ConversionsController.__super__.init.apply(this, arguments);
        }
    });

    return ConversionsController;

})(appCustomerSpace.Controllers.Websites.MainController);
